import http from './api'

const route = 'app/comercial5/'

export default {
  showDevolucaoComercial: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showDevolucaoComercial', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoMesAnteriorComercial: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showDevolucaoMesAnteriorComercial', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoAnoAnteriorComercial: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showDevolucaoAnoAnteriorComercial', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },
}
